
import { ethers } from 'ethers';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import NetworkContext from '../../context/network-context';
import { fetchPairs, fetchUserToken, removeUserToken } from '../../web3/token-utils';
import CoinSelectInput from "../coin-select-input/coin-select-input";


function ExchangeCoinSelectInput({ targetChainId, defaultSelected, selected, onSelect, ...props }) {
    const { pendingTransaction } = useContext(NetworkContext);

    const [, setSelectedValue] = useState(null);
    const [coins, setCoins] = useState(false);
    const [fetching, setFetching] = useState();
    const [search, setSearch] = useState();

    const handleSelect = (coin) => {
        if (pendingTransaction) {
            return;
        }
        setSelectedValue(coin);
        fetchPairs(targetChainId, null, [coin.address]).then(setCoins)
        if (onSelect) {
            onSelect(coin);
        }
    };

    const handleUserTokenRemove = async (token) => {
        removeUserToken(token);
        const _search = ethers.utils.isAddress(search) ? "" : search;
        await loadCoins(_search);
    }

    const loadCoins = useCallback(
        (search) => fetchPairs(targetChainId, search, [defaultSelected.address]).then(data => {
            setCoins(data);
            if (ethers.utils.isAddress(search)) {
                setFetching(true);
                fetchUserToken(search).then(_data => {
                    setCoins([...data, ..._data]);
                    setFetching(false);
                });
            }
        }, []));

    useDebounce(() => {
        loadCoins(search)
    }, 100, [search])

    useEffect(() => {
        fetchPairs(targetChainId, null, [selected ? selected.address : defaultSelected.address]).then(setCoins)
    }, [setCoins, targetChainId, defaultSelected, selected])

    return <CoinSelectInput
        fetching={fetching}
        onSelect={handleSelect}
        onSearch={(value) => setSearch(value)}
        onRemove={handleUserTokenRemove}
        selected={selected}
        defaultSelected={defaultSelected}
        showSearch={true}
        coins={coins}
        {...props} />;
}

export default ExchangeCoinSelectInput;
